// extracted by mini-css-extract-plugin
export default {"form":"PageModal_form__JBgb9"};